// extracted by mini-css-extract-plugin
export default {"logo":"Qaa","cancel":"Raa","stickyheader":"Saa","buttonswrap":"Taa","item":"Uaa","starterKit":"Vaa","boldHeader":"Waa","reviewheader":"Xaa","text":"Yaa","username":"Zaa"};
    if(module.hot) {
      // 1726593108434
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  